/**
 * 旅行終了日（TRIP_TO）を過ぎたしおりのみ「訪問済み」とみなす
 */
export function isTripVisited(shiori) {
  if (!shiori?.TRIP_TO) {
    return false;
  }

  const tripEnd = new Date(shiori.TRIP_TO);
  if (Number.isNaN(tripEnd.getTime())) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  tripEnd.setHours(0, 0, 0, 0);
  return tripEnd < today;
}

export function filterVisitedShiori(shioriList = []) {
  return shioriList.filter(isTripVisited);
}
